// // src/api/filtersApi.js

// const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// // Your provided filter data
// const filterData = {
//   "filter_keys": [
//     "colour_group_name",
//     "department_name",
//     "garment_group_name",
//     "graphical_appearance_name",
//     "section_name"
//   ],
//   "filters": {
//     "colour_group_name": [
//       "Black", "White", "Off White", "Light Beige", "Beige", "Grey", "Light Blue",
//       "Light Grey", "Dark Blue", "Dark Grey", "Pink", "Dark Red", "Greyish Beige",
//       "Light Orange", "Silver", "Gold", "Light Pink", "Dark Pink", "Yellowish Brown",
//       "Blue", "Light Turquoise", "Yellow", "Greenish Khaki", "Dark Yellow", "Other Pink",
//       "Dark Purple", "Red", "Transparent", "Dark Green", "Other Red", "Turquoise",
//       "Dark Orange", "Other", "Orange", "Dark Beige", "Other Yellow", "Light Green",
//       "Other Orange", "Purple", "Light Red", "Light Yellow", "Green", "Light Purple",
//       "Dark Turquoise", "Other Purple", "Bronze/Copper", "Other Turquoise", "Other Green",
//       "Other Blue", "Unknown"
//     ],
//     "department_name": [
//       "Jersey Basic", "Clean Lingerie", "Tights basic", "Baby basics", "Casual Lingerie",
//       "Jersey", "EQ & Special Collections", "Hair Accessories", "Other items", "Baby Nightwear",
//       "Men Sport Woven", "Men Sport Bottoms", "Kids Boy Denim", "Shopbasket Socks", "Socks",
//       "UW", "Young Girl Jersey Basic", "Jacket Street", "Belts", "Divided Shoes", "Swimwear",
//       "Underwear Jersey", "Basic 1", "Tops Knitwear DS", "Men Sport Acc", "Kids Boy Jersey Basic",
//       "Young Girl UW/NW", "Shirt", "Nightwear", "Trouser", "Small Accessories", "Sunglasses",
//       "Gloves/Hats", "Knit & Woven", "Basics", "Accessories", "Jewellery", "Jersey Fancy DS",
//       "Trousers DS", "Bags", "Blazer S&T", "Knitwear", "Woven bottoms", "Shorts", "Dresses DS",
//       "Expressive Lingerie", "Kids Girl UW/NW", "Young Boy Jersey Basic", "Kids Girl S&T",
//       "Young Girl S&T", "Shoes / Boots inactive from s5", "Nursing", "Jersey Fancy", "Shoes",
//       "Functional Lingerie", "Men Sport Tops", "Other Accessories", "Young Boy Trouser",
//       "Outdoor/Blazers DS", "Mama Lingerie", "Socks Bin", "Denim Other Garments",
//       "Everyday Waredrobe Denim", "Trousers", "Denim Trousers", "Outdoor/Blazers",
//       "Young Boy Denim", "Scarves", "Dresses", "Skirts", "Kids Girl Jersey Basic", "Baby Socks",
//       "Trousers & Skirt", "Young Boy Shirt", "Kids Girl Big Acc", "Young Girl Denim", "Flats",
//       "Baby Toys/Acc", "Projects Dresses", "Denim shorts", "Jersey inactive from s1",
//       "Promotion/Other/Offer", "Bags & Items", "Small Bags", "Trouser S&T", "Shirt S&T",
//       "Woven Tops", "Young Girl Knitwear", "Outwear", "Knitwear inactive from s1",
//       "Projects Woven Tops", "Projects Jersey & Knitwear", "Denim wardrobe JKT man inactive from S.6",
//       "Baby Boy Outdoor", "Premium Quality", "Woven inactive from s1", "Tops woven DS",
//       "Newborn", "Skirt", "Jersey License", "Jewellery Extended", "Light Basic Jersey",
//       "Suit Extended inactive from s1", "Young Boy UW/NW", "Tops Knitwear", "Kids Boy Socks",
//       "Young Boy Socks", "Outdoor inactive from s1", "Kids Girl Swimwear", "Young Girl Swimwear",
//       "Ladies Sport Bras", "Ladies Sport Bottoms", "Blazer", "Baby Boy Woven", "Kids Boy Swimwear",
//       "Young boy Swimwear", "Kids Dress-up/Football", "Sneakers small girl inactive from s2",
//       "Tops Woven", "Blouse", "Shorts DS", "Boots", "Kids Boy Big Acc", "Boys Small Acc & Bags",
//       "Woven top", "Young Girl Dresses", "Knitwear Basic", "Sneakers", "Dress", "Baby Girl Woven",
//       "Baby Girl Jersey Fancy", "Jacket Casual", "Kids Boy UW/NW", "Ladies Sport Acc",
//       "Kids Girl Jersey Fancy", "Baby Exclusive", "Young Boy Shorts", "EQ Divided Basics",
//       "Shorts & Skirts", "Promotion/ Other /Offer", "Kids Boy Trouser", "Tops Fancy Jersey",
//       "Kids Girl Knitwear", "Kids Boy Jersey Fancy", "Heels", "Woven Premium", "Blouse & Dress",
//       "Kids Girl Trouser", "Kids Girl Dresses", "Projects Woven Bottoms", "Conscious Exclusive",
//       "Shoes Other", "Kids Girl Outdoor", "Skirts DS", "Young Girl Jersey Fancy", "Young Boy Outdoor",
//       "Young Girl Outdoor", "Woven Occasion", "Kids Boy Outdoor", "Young Boy Jersey Fancy",
//       "Kids Boy Shoes", "Ladies Sport Woven", "Bottoms Girls", "Tops Girls", "Young Girl Big Acc",
//       "Young Boy Shoes", "Young Boy Knitwear", "Suit", "Kids Girl Shoes", "Jacket Smart",
//       "Projects", "Kids Boy Knitwear", "Woven bottoms inactive from S.7", "Jersey/Knitwear Premium",
//       "Sneakers big girl inactive from s2", "Suit jacket", "Kids Boy Shirt", "Jacket",
//       "Kids Girl Denim", "Young Girl Trouser", "Girls Small Acc/Bags", "Shirt Extended inactive from s1",
//       "Tops Boys", "Baby Girl Knitwear", "Baby Shoes", "Jackets", "Jersey Occasion", "Young Boy Big Acc",
//       "Kids Girl License", "Baby Boy Jersey Fancy", "Bottoms Boys", "Local relevance", "Dress-up Boys",
//       "Small Acc. Jewellery & Other", "Baby Boy Knitwear", "Equatorial Assortment", "Loungewear",
//       "Studio Collection", "Woven", "Outwear & Blazers", "Underwear Jersey Fancy inactive from s1",
//       "Special Collection", "Take Care External", "Equatorial", "Divided+", "OL Extended Sizes",
//       "Campaigns", "Underwear Woven", "Heavy Basic Jersey", "EQ JKT Man", "Young Girl Shoes",
//       "AK Other", "Kids Boy Shorts", "Bottoms", "Shopbasket Lingerie", "Kids Boy License",
//       "Baby Girl Outdoor", "Promotion / Other / Offer", "Divided+ inactive from s.1",
//       "Tops & Bottoms Other", "Take care", "Girls Local Relevance", "AK Dresses & Outdoor",
//       "Limited Edition", "AK Tops Jersey & Woven", "AK Tops Knitwear", "Divided Swimwear",
//       "AK Bottoms", "Girls Projects", "On Demand", "Test Ladies", "Socks Wall", "Jersey inactive from S.6",
//       "Boys Local Relevance", "License", "Price Items", "Asia Assortment", "Accessories Boys",
//       "Read & React", "EQ Ladies Denim", "Small Accessories Extended", "Baby Boy Local Relevance",
//       "Kids Girl Exclusive", "Baby Girl Local Relevance", "EQ Divided Blue", "Kids Boy Exclusive",
//       "Accessories Other", "Blanks"
//     ],
//     "garment_group_name": [
//       "Jersey Basic", "Under-, Nightwear", "Socks and Tights", "Jersey Fancy", "Accessories",
//       "Trousers Denim", "Outdoor", "Shoes", "Swimwear", "Knitwear", "Shirts", "Trousers",
//       "Dressed", "Shorts", "Dresses Ladies", "Skirts", "Special Offers", "Blouses", "Unknown",
//       "Woven/Jersey/Knitted mix Baby", "Dresses/Skirts girls"
//     ],
//     "graphical_appearance_name": [
//       "Solid", "Stripe", "All over pattern", "Melange", "Transparent", "Metallic",
//       "Application/3D", "Denim", "Colour blocking", "Dot", "Other structure", "Contrast",
//       "Treatment", "Check", "Chambray", "Front print", "Glittering/Metallic", "Mixed solid/pattern",
//       "Placement print", "Other pattern", "Neps", "Embroidery", "Lace", "Jacquard", "Unknown",
//       "Argyle", "Slub", "Mesh", "Sequin", "Hologram"
//     ],
//     "section_name": [
//       "Womens Everyday Basics", "Womens Lingerie", "Womens Nightwear, Socks & Tigh",
//       "Baby Essentials & Complements", "Men Underwear", "Mama", "Womens Small accessories",
//       "Men JKT Sport", "Kids Boy", "Divided Basics", "Girls Underwear & Basics", "Mens Outerwear",
//       "Womens Big accessories", "Divided Accessories", "Womens Swimwear, beachwear",
//       "Divided Selected", "Boys Underwear & Basics", "Contemporary Street", "Contemporary Casual",
//       "Men Accessories", "Men Suits & Tailoring", "Womens Everyday Collection", "Men Shoes",
//       "Young Boy", "JKT+", "Divided Collection", "Ladies Denim", "Contemporary Smart",
//       "Womens Trend", "Kids Outerwear", "Young Girl", "Womens Shoes", "Womens Tailoring",
//       "Divided Projects", "Denim Men", "Men Other", "Womens Jackets", "Men Other 2", "Baby Boy",
//       "Womens Casual", "Kids Accessories, Swimwear & D", "Ladies JKT Sport", "Kids & Baby Shoes",
//       "Baby Girl", "Kids Girl", "Divided Complements Other", "Womens Premium", "Special Collections",
//       "Kids Sports", "Men Project", "Men Edition", "Collaborations", "Divided Asia keys",
//       "EQ Divided", "Kids Local Relevance", "Ladies Other"
//     ]
//   }
// };

// /**
//  * Simulates API call to fetch filter options
//  * @returns {Promise<Object>} - Filter data
//  */
// export const fetchFilters = async () => {
//   await sleep(500); // Simulate network delay
//   return filterData;
// };

// src/api/filtersApi.js
import { getErrorMessage } from "../config/errorConfig";
import { FILTER_OPTIONS_URL } from "../config/apiConfig";

export const fetchFilters = async () => {
  const url = FILTER_OPTIONS_URL;



  try {
    let response;

      // Public request (no token)
      response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    

  if (!response.ok) {
      // Map HTTP status to user-friendly error
      let errorMessage;
      if (response.status >= 500) {
        errorMessage = getErrorMessage("API_SERVER_ERROR");
      } else if (response.status === 404) {
        errorMessage = getErrorMessage("API_NOT_FOUND");
      } else if (response.status === 429) {
        errorMessage = getErrorMessage("API_RATE_LIMITED");
      } else {
        errorMessage = getErrorMessage("API_BAD_REQUEST");
      }

      throw new Error(errorMessage);
    }
    const data = await response.json();

    return data;
  } catch (error) {
     if (error.message.includes("Failed to fetch")) {
      throw new Error(getErrorMessage("NETWORK_SERVER_UNREACHABLE"));
    }else{
        throw error;
    }
  }
};